/**
 * Date-extensions locale Romanian [ro]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ro', {
    monthNames: ['Ianuarie','Februarie','Martie','Aprilie','Mai','Iunie','Iulie','August','Septembrie','Octombrie','Noiembrie','Decembrie'],
    monthShortNames: ['Ian.','Febr.','Mart.','Apr.','Mai','Iun.','Iul.','Aug.','Sept.','Oct.','Nov.','Dec.'],
    dayNames: ['Duminică','Luni','Marți','Miercuri','Joi','Vineri','Sâmbătă'],
    dayShortNames: ['Dum','Lun','Mar','Mie','Joi','Vin','Sâm']
});
